export default "__VITE_ASSET__a9Q_w9t90Id2SZCArinhzQ__"